import {Injectable} from "@angular/core";
import {ModalController, ModalOptions} from "@ionic/angular";
import {fromEvent, Subscription} from "rxjs";

export type ModalType = "modal" | "card" | "sheet-quarter" | "sheet-half" | "sheet-three-quarter" | "sheet-full";

@Injectable()
export class ModalService {
    constructor(
        private readonly modal: ModalController,
    ) {
        // nothing
    }

    create(options: ModalOptions, type: ModalType = "sheet-half", cssClass: "normal"|"narrow"|"small"|"large"|"full"|"full-width"|"auto-height w-sm"|"auto-height w-md"|"auto-height w-lg" = null, onDismiss: () => void = null): Promise<HTMLIonModalElement> {
        if (cssClass) options.cssClass = cssClass;
        switch (type) {
            case "modal":
                options.backdropDismiss = true;
                break;
            case "card":
                options.swipeToClose = true;
                // options.presentingElement = pageEl;
                break;
            case "sheet-quarter":
                options.breakpoints = [0, 0.25, 0.75, 1];
                options.initialBreakpoint = 0.25;
                break;
            case "sheet-half":
                options.breakpoints = [0, 0.75, 1];
                options.initialBreakpoint = 0.75;
                break;
            case "sheet-three-quarter":
                options.breakpoints = [0, 0.85, 1];
                options.initialBreakpoint = 0.95;
                break;
            case "sheet-full":
                options.breakpoints = [0, 1];
                options.initialBreakpoint = 1;
                break;
        }
        return new Promise((resolve, reject) => {
            this.modal.create(options).then(modal => {
                modal.present();
                modal.onDidDismiss().then((result) => {
                    if (onDismiss) {
                        onDismiss();
                    }
                });
                resolve(modal);
            }, (error) => {
                reject(error);
            });
        });
    }

    dismiss(data?: any, role?: string, id?: string): Promise<boolean> {
        return this.modal.dismiss(data, role, id);
    }
}
